<template>
  <v-dialog
    v-model="dialog"
    overlay-opacity="0"
  >
    <v-card>
      <div class="px-3 py-2">
        <h5 v-if="title" class="font-weight-light">
          <b>{{ title }}</b>
        </h5>
      </div>
      <v-card-text v-if="detail">
        {{ detail }}
      </v-card-text>
      <div class="px-3">
        <v-text-field
          dense
          type="text"
          v-model="text"
          outlined
          readonly
          disabled
          hide-details
        ></v-text-field>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          text
          @click="dialog = false"
          class="os-rounded"
        >
          <b>{{$t('basics.cancel')}}</b>
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="handler()"
          class="os-rounded"
        >
          <b>{{ action }}</b>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    title: {
      type: String,
      default: null
    },
    detail: {
      type: String,
      default: null
    },
    action: {
      type: String,
      default: 'Copiar'
    },
    text: {
      required: true,
      type: String,
      default: null
    }
  }
})
export default class CopyText extends Vue {
  data () {
    return {
      dialog: false
    }
  }

  toggle () {
    this.dialog = !this.dialog
  }

  handler () {
    this.copy()
    this.dialog = false
    this.$emit('confirmHandler')
  }

  copy () {
    if (window.isSecureContext) {
      navigator.clipboard.writeText(this.text)
    }
  }
}
</script>
